import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { DATA_DOG, Env, ENV_VARS } from './config';

let isInitialized = false;

const initIfNotInit = (env: Env) => {
  if (!isInitialized) {
    isInitialized = true;

    datadogRum.init({
      applicationId: DATA_DOG.APP_ID,
      clientToken: DATA_DOG.CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'ehandelsportalen',
      env,
      sampleRate: 100,
      sessionReplaySampleRate: env === 'prod' ? 15 : 0,
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
      allowedTracingOrigins: [ENV_VARS[env].HOST],
    });

    datadogRum.startSessionReplayRecording();
  }
};

export const useDataDogMonitoring = (env: Env) => {
  useEffect(() => {
    initIfNotInit(env);
  }, [env]);
};
